import type { BaseOrganisation } from './customers';

export const prepareCustomer = (customer: BaseOrganisation): MutationBody => ({
  data: {
    type: 'Customer',
    attributes: {
      name: customer.name,
      phone: customer.phone,
      street: customer.street,
      suburb: customer.suburb,
      city: customer.city,
      postcode: customer.postcode,
      country: customer.country,
      ...(customer.identifier ? { identifier: customer.identifier } : {}),
      ...(customer.rating ? { rating: customer.rating } : {}),
      ...(customer.customerType
        ? {
            customerType: {
              id: `/api/v2/customer-types/${customer.customerType.id}`,
              type: 'CustomerType'
            }
          }
        : {})
    }
  }
});
